import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import propTypes from "prop-types"
import { fetchNotifications } from "../../../../services/notifications"
import { validateForm } from "../../../../services/validation"
import {
  signOut,
  fetchDisabilities,
  setNewPassword,
  saveUserData
} from "../../../../services/authentication"
import "./styles.scss"

import Header from "../../../../components/Header"
import Footer from "../../../../components/Footer"
import Button from "../../../../components/Button"
import Form, {
  Group,
  Input,
  Password,
  Select
} from "../../../../components/Form"

class Profile extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      PIForm: {
        firstName: {
          label: "First Name",
          name: "firstName",
          type: "text",
          value: "",
          required: true
        },
        lastName: {
          label: "Last Name",
          name: "lastName",
          type: "text",
          value: "",
          required: true
        },
        phone: {
          label: "Phone",
          name: "phone",
          type: "text",
          value: "",
          required: false
        },
        address: {
          label: "Address",
          name: "address",
          type: "text",
          value: "",
          required: false
        }
      },
      GIForm: {
        NDISNumber: {
          label: "NDIS Number",
          name: "NDISNumber",
          type: "text",
          value: "",
          required: false,
          class: "",
          message: ""
        },
        primaryDisability: {
          label: "Primary Disability",
          name: "primaryDisability",
          placeholder: "Search for my disability",
          value: "",
          options: [],
          required: true,
          class: "",
          message: ""
        },
        secondaryDisability: {
          label: "Secondary Disability",
          name: "secondaryDisability",
          placeholder: "Search for my disability",
          value: "",
          options: [],
          required: false,
          class: "",
          message: ""
        }
      },
      updatePassword: {
        currentPassword: {
          label: "Current Password",
          name: "currentPassword",
          type: "password",
          value: "",
          required: true
        },
        newPassword: {
          label: "New Password",
          name: "newPassword",
          type: "password",
          value: "",
          required: true
        },
        confirmPassword: {
          label: "Confirm Password",
          name: "confirmPassword",
          type: "password",
          value: "",
          required: true,
          requiredField: "newPassword"
        }
      },
      updatePasswordGlobalMessages: {
        success: "",
        error: ""
      },
      PIFormIsHidden: true,
      GIFormIsHidden: true,
      isSubmitted: false,
      innerLoading: false
    }
  }

  componentDidMount() {
    const {
      store: { user },
      onFetchNotifications
    } = this.props

    onFetchNotifications(user.token)

    fetchDisabilities()
      .then(data => {
        const options = []

        if (data.length) {
          data.map(item => {
            options.push({
              label: item.name,
              value: String(item.id)
            })

            return null
          })

          const { GIForm } = this.state

          this.setState({
            GIForm: {
              ...GIForm,
              primaryDisability: {
                ...GIForm.primaryDisability,
                options
              },
              secondaryDisability: {
                ...GIForm.secondaryDisability,
                options
              }
            }
          })
        }
      })
      .catch(() => {})

    const { PIForm, GIForm } = this.state

    this.setState({
      PIForm: {
        firstName: {
          ...PIForm.firstName,
          value: user.name ? user.name : ""
        },
        lastName: {
          ...PIForm.lastName,
          value: user.last_name ? user.last_name : ""
        },
        phone: {
          ...PIForm.phone,
          value: user.phone ? user.phone : ""
        },
        address: {
          ...PIForm.address,
          value: user.address ? user.address : ""
        }
      },
      GIForm: {
        NDISNumber: {
          ...GIForm.NDISNumber,
          value: user.ndis_number ? user.ndis_number : ""
        },
        primaryDisability: {
          ...GIForm.primaryDisability,
          value: user.primary_disability ? user.primary_disability : ""
        },
        secondaryDisability: {
          ...GIForm.secondaryDisability,
          value: user.secondary_disability ? user.secondary_disability : ""
        }
      }
    })
  }

  toggleForm = (e, type) => {
    if (e) e.preventDefault()

    const prevState = this.state[`${type}IsHidden`]

    this.setState({ [`${type}IsHidden`]: !prevState })
  }

  onChange = (name, field, value, type) => {
    const form = this.state[type]
    const newState = {
      [type]: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    }

    this.setState(newState)
  }

  handleUpdatePassword = () => {
    const {
      store: { user }
    } = this.props
    const { updatePassword } = this.state

    this.setState({ innerLoading: true })

    const results = validateForm(updatePassword)

    if (Object.keys(results).length === 0 && results.constructor === Object) {
      setNewPassword(user.token, {
        old_password: updatePassword.currentPassword.value,
        new_password: updatePassword.newPassword.value,
        confirm_password: updatePassword.confirmPassword.value
      }).then(
        message => {
          this.setState({
            updatePasswordGlobalMessages: {
              success: message,
              error: ""
            },
            updatePassword: {
              currentPassword: {
                ...updatePassword.currentPassword,
                value: ""
              },
              newPassword: {
                ...updatePassword.newPassword,
                value: ""
              },
              confirmPassword: {
                ...updatePassword.confirmPassword,
                value: ""
              }
            },
            innerLoading: false
          })
        },
        error => {
          const newState = {
            updatePassword: {
              ...updatePassword
            },
            updatePasswordGlobalMessages: {
              success: "",
              error: ""
            },
            innerLoading: false,
            isSubmitted: true
          }

          if (error.error) {
            newState.updatePasswordGlobalMessages.error = error.error
          }

          if (error.new_password) {
            newState.updatePassword.newPassword.message = error.new_password[0]
          }

          if (error.confirm_password) {
            newState.updatePassword.confirmPassword.message =
              error.confirm_password[0]
          }

          this.setState(newState)
        }
      )
    } else {
      this.setState({
        isSubmitted: true,
        innerLoading: false,
        updatePassword: {
          ...updatePassword,
          ...results
        }
      })
    }
  }

  handleUpdateUser = formName => {
    const {
      store: { user },
      onSaveUserData
    } = this.props
    const { PIForm, GIForm } = this.state

    this.setState({ innerLoading: true })

    const results = validateForm(this.state[formName])

    if (Object.keys(results).length === 0 && results.constructor === Object) {
      let data

      if (formName === "PIForm") {
        data = {
          first_name: PIForm.firstName.value,
          last_name: PIForm.lastName.value,
          phone: PIForm.phone.value || null,
          address: PIForm.address.value || null
        }
      } else if (formName === "GIForm") {
        data = {
          ndis_number: GIForm.NDISNumber.value,
          primary_disability: GIForm.primaryDisability.value,
          secondary_disability: GIForm.secondaryDisability.value
            ? GIForm.secondaryDisability.value
            : null
        }
      }

      onSaveUserData(data, user.token).then(
        () => {
          this.setState({
            innerLoading: false,
            [`${formName}IsHidden`]: true
          })
        },
        error => {
          const newState = {
            [formName]: {
              ...this.state[formName]
            },
            innerLoading: false,
            isSubmitted: true
          }

          if (error && error.first_name) {
            newState[formName].firstName.message = error.first_name[0]
          }
          if (error && error.last_name) {
            newState[formName].lastName.message = error.last_name[0]
          }
          if (error && error.ndis_number) {
            newState[formName].NDISNumber.message = error.ndis_number[0]
          }
          if (error && error.phone) {
            newState[formName].phone.message = error.phone[0]
          }
          if (error && error.primary_disability) {
            newState[formName].primaryDisability.message =
              error.primary_disability[0]
          }
          if (error && error.address) {
            newState[formName].address.message = error.address[0]
          }

          this.setState(newState)
        }
      )
    } else {
      const errorState = {
        isSubmitted: true,
        innerLoading: false,
        [formName]: {
          ...this.state[formName],
          ...results
        }
      }

      this.setState(errorState)
    }
  }

  render() {
    const {
      onSignOut,
      store: { notificationCount, user }
    } = this.props
    const {
      PIForm,
      PIFormIsHidden,
      GIForm,
      GIFormIsHidden,
      isSubmitted,
      updatePassword,
      updatePasswordGlobalMessages,
      innerLoading
    } = this.state

    let primaryDisability = "--"
    let secondaryDisability = "--"

    GIForm.primaryDisability.options.map(option => {
      if (option.value === GIForm.primaryDisability.value) {
        primaryDisability = option.label
      }

      return null
    })

    GIForm.secondaryDisability.options.map(option => {
      if (option.value === GIForm.secondaryDisability.value) {
        secondaryDisability = option.label
      }

      return null
    })

    return (
      <div className="main-container main-container--light">
        <Header theme="dark" hideNotifications />

        <div className="content profile">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <div className="profile_sidebar">
                  <div className="content_section_header">
                    <h1 className="content_section_title">
                      {user.name}’s Profile
                    </h1>
                  </div>

                  <h2 className="profile_sidebar_nav_title">
                    Profile Infomation
                  </h2>
                  <nav className="profile_sidebar_nav">
                    <ul>
                      <li>
                        <Link to="/#">Support Team</Link>
                      </li>
                      <li>
                        <Link to="/#">Service Providers</Link>
                      </li>
                      <li>
                        <Link to="/#">
                          Notifications
                          {!!notificationCount && (
                            <span className="profile_sidebar_nav_notification-count">
                              {notificationCount}
                            </span>
                          )}
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">Current Plan Activity </Link>
                      </li>
                      <li>
                        <Link to="/#">Historical Plans</Link>
                      </li>
                    </ul>
                  </nav>

                  <button
                    className="btn-signout"
                    type="button"
                    onClick={onSignOut}
                  >
                    Sign Out
                  </button>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="profile_content">
                  <div className="profile_content_section">
                    <h2 className="profile_content_section_title">
                      Personal Information
                    </h2>

                    <div className="row">
                      <div className="col-lg-8">
                        {PIFormIsHidden ? (
                          <div className="profile_content_section_info">
                            <div className="profile_content_section_info_item">
                              <div className="profile_content_section_info_label">
                                First Name
                              </div>
                              <div className="profile_content_section_info_text">
                                {PIForm.firstName.value
                                  ? PIForm.firstName.value
                                  : "--"}
                              </div>
                            </div>

                            <div className="profile_content_section_info_item">
                              <div className="profile_content_section_info_label">
                                Last Name
                              </div>
                              <div className="profile_content_section_info_text">
                                {PIForm.lastName.value
                                  ? PIForm.lastName.value
                                  : "--"}
                              </div>
                            </div>

                            <div className="profile_content_section_info_item">
                              <div className="profile_content_section_info_label">
                                Phone
                              </div>
                              <div className="profile_content_section_info_text">
                                {PIForm.phone.value ? PIForm.phone.value : "--"}
                              </div>
                            </div>

                            <div className="profile_content_section_info_item">
                              <div className="profile_content_section_info_label">
                                Address
                              </div>
                              <div className="profile_content_section_info_text">
                                {PIForm.address.value
                                  ? PIForm.address.value
                                  : "--"}
                              </div>
                            </div>

                            <a
                              onClick={e => this.toggleForm(e, "PIForm")}
                              href="/#"
                              className="profile_content_section_info_edit"
                            >
                              edit
                            </a>
                          </div>
                        ) : (
                          <Form onSubmit={this.onSubmit}>
                            <Group>
                              <Input
                                onChange={(name, field, value) =>
                                  this.onChange(name, field, value, "PIForm")
                                }
                                isSubmitted={isSubmitted}
                                field={PIForm.firstName}
                              />
                            </Group>

                            <Group>
                              <Input
                                onChange={(name, field, value) =>
                                  this.onChange(name, field, value, "PIForm")
                                }
                                isSubmitted={isSubmitted}
                                field={PIForm.lastName}
                              />
                            </Group>

                            <Group>
                              <Input
                                onChange={(name, field, value) =>
                                  this.onChange(name, field, value, "PIForm")
                                }
                                isSubmitted={isSubmitted}
                                field={PIForm.phone}
                              />
                            </Group>

                            <Group>
                              <Input
                                onChange={(name, field, value) =>
                                  this.onChange(name, field, value, "PIForm")
                                }
                                isSubmitted={isSubmitted}
                                field={PIForm.address}
                              />
                            </Group>

                            <Group className="form_group--padding-top-lg">
                              <Button
                                onClick={() => this.handleUpdateUser("PIForm")}
                                button={{
                                  type: "button",
                                  disabled: innerLoading
                                }}
                                className="btn--secondary-light btn--width-lg btn--height-sm"
                              >
                                Update
                              </Button>
                            </Group>

                            <Group>
                              <a
                                onClick={e => this.toggleForm(e, "PIForm")}
                                href="/#"
                                className="profile_content_section_info_edit"
                              >
                                cancel
                              </a>
                            </Group>
                          </Form>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="profile_content_section">
                    <h2 className="profile_content_section_title">
                      General Information
                    </h2>

                    <div className="row">
                      <div className="col-lg-8">
                        {GIFormIsHidden ? (
                          <div className="profile_content_section_info">
                            <div className="profile_content_section_info_item">
                              <div className="profile_content_section_info_label">
                                NDIS Number
                              </div>
                              <div className="profile_content_section_info_text">
                                {GIForm.NDISNumber.value
                                  ? GIForm.NDISNumber.value
                                  : "--"}
                              </div>
                            </div>

                            <div className="profile_content_section_info_item">
                              <div className="profile_content_section_info_label">
                                Primary Disability{" "}
                              </div>
                              <div className="profile_content_section_info_text">
                                {primaryDisability}
                              </div>
                            </div>

                            <div className="profile_content_section_info_item">
                              <div className="profile_content_section_info_label">
                                Secondary Disability
                              </div>
                              <div className="profile_content_section_info_text">
                                {secondaryDisability}
                              </div>
                            </div>

                            <a
                              onClick={e => this.toggleForm(e, "GIForm")}
                              href="/#"
                              className="profile_content_section_info_edit"
                            >
                              edit
                            </a>
                          </div>
                        ) : (
                          <Form onSubmit={this.onSubmit}>
                            <Group>
                              <Input
                                onChange={(name, field, value) =>
                                  this.onChange(name, field, value, "GIForm")
                                }
                                isSubmitted={isSubmitted}
                                field={GIForm.NDISNumber}
                              />
                            </Group>

                            <Group>
                              <Select
                                onChange={(name, field, value) =>
                                  this.onChange(name, field, value, "GIForm")
                                }
                                isSubmitted={isSubmitted}
                                field={GIForm.primaryDisability}
                              />
                            </Group>

                            <Group>
                              <Select
                                onChange={(name, field, value) =>
                                  this.onChange(name, field, value, "GIForm")
                                }
                                isSubmitted={isSubmitted}
                                field={GIForm.secondaryDisability}
                              />
                            </Group>

                            <Group className="form_group--padding-top-lg">
                              <Button
                                onClick={() => this.handleUpdateUser("GIForm")}
                                button={{
                                  type: "button",
                                  disabled: innerLoading
                                }}
                                className="btn--secondary-light btn--width-lg btn--height-sm"
                              >
                                Update
                              </Button>
                            </Group>

                            <Group>
                              <a
                                onClick={e => this.toggleForm(e, "GIForm")}
                                href="/#"
                                className="profile_content_section_info_edit"
                              >
                                cancel
                              </a>
                            </Group>
                          </Form>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="profile_content_section">
                    <h2 className="profile_content_section_title">
                      Update Your Password
                    </h2>

                    <div className="row">
                      <div className="col-lg-8">
                        <Form onSubmit={this.onSubmit}>
                          <div className="form_global_messages">
                            {updatePasswordGlobalMessages.success && (
                              <span className="form_global_messages--success">
                                {updatePasswordGlobalMessages.success}
                              </span>
                            )}

                            {updatePasswordGlobalMessages.error && (
                              <span className="form_global_messages--error">
                                {updatePasswordGlobalMessages.error}
                              </span>
                            )}
                          </div>
                          <Group>
                            <Password
                              onChange={(name, field, value) =>
                                this.onChange(
                                  name,
                                  field,
                                  value,
                                  "updatePassword"
                                )
                              }
                              isSubmitted={isSubmitted}
                              field={updatePassword.currentPassword}
                            />
                          </Group>

                          <Group>
                            <Password
                              onChange={(name, field, value) =>
                                this.onChange(
                                  name,
                                  field,
                                  value,
                                  "updatePassword"
                                )
                              }
                              isSubmitted={isSubmitted}
                              field={updatePassword.newPassword}
                            />
                          </Group>

                          <Group>
                            <Password
                              onChange={(name, field, value) =>
                                this.onChange(
                                  name,
                                  field,
                                  value,
                                  "updatePassword"
                                )
                              }
                              isSubmitted={isSubmitted}
                              field={updatePassword.confirmPassword}
                            />
                          </Group>

                          <Group className="form_group--padding-top-lg">
                            <Button
                              onClick={this.handleUpdatePassword}
                              button={{
                                type: "button",
                                disabled: innerLoading
                              }}
                              className="btn--empty-secondary-light btn--width-lg btn--height-sm"
                            >
                              Update Password
                            </Button>
                          </Group>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    )
  }
}

Profile.propTypes = {
  store: propTypes.shape({
    notifications: propTypes.arrayOf(
      propTypes.shape({
        id: propTypes.oneOfType([propTypes.string, propTypes.number]),
        description: propTypes.string,
        href: propTypes.string
      })
    ),
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string,
      last_name: propTypes.string,
      phone: propTypes.string,
      address: propTypes.string,
      ndis_number: propTypes.string,
      primary_disability: propTypes.string,
      secondary_disability: propTypes.string
    }),
    notificationCount: propTypes.oneOfType([propTypes.string, propTypes.number])
      .isRequired
  }).isRequired,
  onFetchNotifications: propTypes.func.isRequired,
  onSaveUserData: propTypes.func.isRequired,
  onSignOut: propTypes.func.isRequired
}

const mapStateToProps = ({ NotificationsReducer, AuthenticationReducer }) => ({
  store: {
    notificationCount: NotificationsReducer.unreadCounter,
    user: AuthenticationReducer.user
  }
})

const mapDispatchToProps = dispatch => ({
  onFetchNotifications: token => dispatch(fetchNotifications(token)),
  onSaveUserData: (data, token) => dispatch(saveUserData(data, token)),
  onSignOut: () => dispatch(signOut())
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
